export default {
    // 页面标题
    PvPTFgameTitle: "火箭升空-判断对错游戏设置",
    
    // 设置区域
    topicLabel: "主题",
    inputTopic: "请输入主题",
    questionLabel: "题目",
    inputQuestion: "请输入题目",
    addQuestion: "新增题目",
    correctAnswer: "正确",
    wrongAnswer: "错误",
    gameDuration: "游戏时长",
    second: "秒",
    saveSettings: "保存设置",
    answerMode: "作答模式",
    syncMode: "同步跳题",
    individualMode: "各自进度跳题(做答完直接跳下一题)",
    
    // 提示信息
    maxQuestions: "最多只能添加20个题目",
    questionExists: "题目已存在",
    errorItems:"错误题目",
    correctItems:"正确题目",
    
    // 按钮文字
    addQuestionButton: "新增题目",
    saveSettingsButton: "保存设置",

    startGame: "开始游戏",
    pauseGame: "暂停游戏",
    resumeGame: "继续游戏",
    gameOver: "游戏结束",
    leftSide: "左方",
    rightSide: "右方",
    leftWins: "左方获胜！",
    rightWins: "右方获胜！",
    tie: "平局！",
    topic: "主题",
    
    // 游戏结束画面新增字符串
    win: "胜利",
    items: "个",
    wrongItems: "答对题目",
    maxCombo: "最高连击",
    showAnswers: "A",
    gamePaused: "活动暂停",
    referenceAnswers: "参考答案",
    answered: "已作答",
    clearData: "清除数据",
    answerTime: "作答时间",
    sendSuccess: "游戏资料已成功推送！",
    sendCooldown: "已按送出，请等候1分钟才可再操作",
    pushSuccess: "游戏已成功推送到 HiTeach！",
    pushFailed: "推送失败：{message}",
    tokenRefreshing: "正在刷新授权资讯，请稍后再试...",
    configLoadSuccess: "成功加载游戏配置",
    configLoadFailed: "加载失败（使用示例配置）",
}
